import React, {useState} from 'react'
import './ChangeLoraIdModal.scss'
import {useDispatch, useSelector} from "react-redux";
import {getSensors, updateLoraIdentifier} from "../store/actions/sensorsActions";

const selector = state => {
    const { language, disableButtons, sensors } = state;
    return {
        t: language.translator,
        disableButtons: disableButtons,
        selected: sensors.selected,
    }
};

const ChangeLoraIdModal = props => {
    const { t, selected} = useSelector(selector);
    const {closeMethod, itemsPerPage, filter, search, reload} = props;
    const dispatch = useDispatch();

    const [loraId, setLoraId] = useState('')


    const handleChangeIdClick = () => {
        dispatch(updateLoraIdentifier(selected.sensor.id, loraId))
        closeMethod()
        dispatch(getSensors(1, itemsPerPage, filter, 0, search, null, null, null));
        reload()
    }

    return (
        <div className="loraChangeContainer">
            <div className='loraHeader'>{t.gettext('You are changing Lora Identifier for sensor! Are you sure?')}</div>
            <div className='fieldFormItem'>
                <label className='fieldFormLabel'>
                    {t.gettext('Lora Identifier')}
                </label>
                <input
                    className='loraInput'
                    onInput={e => {
                        setLoraId(e.target.value);
                    }}
                    type='text'
                />
            </div>
            <div className="loraBtnWrapper">
                <button
                    className='changeLoraBtn saveLoraBtn'
                    onClick={e => {
                        e.preventDefault();
                        handleChangeIdClick()
                    }}
                    disabled={!loraId}
                >
                    {t.gettext('Save')}
                </button>
                <button
                    className='changeLoraBtn cancelLoraBtn'
                    onClick={e => {
                        e.preventDefault();
                        closeMethod()
                    }}
                >
                    {t.gettext('Cancel')}
                </button>

            </div>
        </div>
    )
}

export default ChangeLoraIdModal
